import { useContext, useEffect } from 'react'
import { Route, Routes as Switch, useLocation, useNavigate } from 'react-router-dom'

import PageLayout from '../components/PageLayout/PageLayout'
import AppContext from '../context/AppContext'
import DeliveryMethodsPage from '../DeliveryMethodsPage'
import EvaluationOptOutPage from '../EvaluationOptOutPage/EvaluationOptOutPage'
import ExchangeAddressPage from '../ExchangeAddressPage'
import FindOrdersPage from '../FindOrdersPage'
import { isTokenExpired } from '../helpers'
import userEvents from '../helpers/userEvents/userEvents'
import MerchantHomePage from '../MerchantHomePage'
import NotFoundPage from '../NotFoundPage/NotFoundPage'
import ProcessCompletedPage from '../ProcessCompletedPage'
import ProductsSelectionPage from '../ProductsSelectionPage'
import RecoveredOrdersPage from '../RecoveredOrdersPage'
import RefundSelectionPage from '../RefundSelectionPage'
import SuccessPage from '../SuccessPage/SuccessPage'
import SummaryPage from '../SummaryPage'
import VerifyEmailPage from '../VerifyEmailPage'
import AuthRoute from './AuthRoute'
import routes from './routes.constants'

const Routes = () => {
  const location = useLocation()
  const { context } = useContext(AppContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (
      location.pathname !== routes.evaluationOptOutPage &&
      localStorage.jwt &&
      isTokenExpired(localStorage.jwt) &&
      context?.merchantInfo?.slug
    ) {
      navigate(`/${context.merchantInfo.slug}`)
    }
  }, [context.merchantInfo.slug, navigate, location.pathname])

  useEffect(() => {
    userEvents.changePath(location.pathname)
  }, [location])

  return (
    <>
      <Switch location={location}>
        <Route path="/:slug?" element={<MerchantHomePage />} />
        <Route path={`/:slug?${routes.findOrdersPage}`} element={<FindOrdersPage />} />
        <Route path={`/:slug?${routes.recoveredOrdersPage}`} element={<RecoveredOrdersPage />} />
        <Route path={routes.evaluationOptOutPage} element={<EvaluationOptOutPage />} />
        <Route element={<PageLayout />}>
          <Route
            path={routes.productSelectionPage}
            element={
              <AuthRoute>
                <ProductsSelectionPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.deliveryMethodsPage}
            element={
              <AuthRoute>
                <DeliveryMethodsPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.exchangeAddressPage}
            element={
              <AuthRoute>
                <ExchangeAddressPage />
              </AuthRoute>
            }
          />

          <Route
            path={routes.summaryPage}
            element={
              <AuthRoute>
                <SummaryPage />
              </AuthRoute>
            }
          />
          <Route path={routes.processCompletedPage} element={<ProcessCompletedPage />} />
          <Route
            path={routes.verifyEmailPage}
            element={
              <AuthRoute>
                <VerifyEmailPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.refundSelectionPage}
            element={
              <AuthRoute>
                <RefundSelectionPage />
              </AuthRoute>
            }
          />
          <Route path={routes.successPage} element={<SuccessPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Switch>
    </>
  )
}

export default Routes
